<template>
  <v-app-bar
    :color="$vuetify.breakpoint.smAndUp ? 'transparent' : 'white'"
    :flat="!$vuetify.breakpoint.xsOnly"
    app
    absolute
    dense
  >
    <v-app-bar-nav-icon @click.stop="$emit('toggleSidebar')" />

    <v-toolbar-items>
      <v-btn
        v-if="$route.name === 'task' || $route.path === '/tasks/new'"
        icon
        @click="$router.go(-1)"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </v-toolbar-items>

    <v-spacer />

    <v-toolbar-items>
      <v-menu
        bottom
        nudge-bottom="48px"
        attach="header.v-app-bar"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            class="text-none"
            small
            v-on="on"
          >
            {{ units === 'metric' ? 'Metric' : (units === 'imperial' ? 'Imperial' : '') }}
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item @click="setUnits('metric')">
            <v-list-item-content>
              <v-list-item-title>
                Metric
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="setUnits('imperial')">
            <v-list-item-content>
              <v-list-item-title>
                Imperial
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        bottom
        left
        attach="header.v-app-bar"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item :to="{ path: '/logout' }">
            <v-list-item-avatar>
              <v-icon>exit_to_app</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Log Out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar> <!-- end toolbar -->
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Toolbar',
  data() {
    return {
      drawer: false
    }
  },
  computed: {
    units() {
      if (!this.$store.state.auth.user) return 'metric'

      return this.$store.state.auth.user.units
    },
    exchangeRateEurUsd() {
      const pair = this.currencyExchangeRates.data.find(r => r.base === 'EUR' && r.quote === 'USD' && r.year === (new Date()).getFullYear())

      if (pair) return pair.rate

      return undefined
    },
    ...mapState('settings', ['currencyExchangeRates'])
  },
  methods: {
    setUnits(unit) {
      this.$store.dispatch('auth/changeUnits', unit)
    }
  }
}
</script>
